var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomInOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.259 10.535H7.12q-.485 0-.81-.327a1.1 1.1 0 0 1-.328-.811q0-.485.327-.81.327-.328.81-.328H8.26V7.12q0-.485.327-.81.327-.328.81-.328.485 0 .812.327t.327.81V8.26h1.138q.483 0 .81.327a1.1 1.1 0 0 1 .328.81 1.1 1.1 0 0 1-.327.812 1.1 1.1 0 0 1-.811.327h-1.138v1.138q0 .483-.327.81a1.1 1.1 0 0 1-.811.328 1.1 1.1 0 0 1-.81-.327 1.1 1.1 0 0 1-.328-.811zm1.138 6.259q-3.1 0-5.25-2.148Q2 12.498 2 9.396q0-3.1 2.148-5.248T9.397 2t5.249 2.148q2.148 2.148 2.148 5.249a6.93 6.93 0 0 1-1.48 4.324l6.373 6.373q.313.312.313.796t-.313.797a1.08 1.08 0 0 1-.797.313q-.483 0-.796-.313l-6.373-6.373a6.934 6.934 0 0 1-4.324 1.48m0-2.276q2.133 0 3.627-1.494t1.494-3.627-1.494-3.627Q11.53 4.276 9.397 4.276T5.77 5.77 4.276 9.397q0 2.133 1.494 3.627t3.627 1.494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInOutline);
export default __webpack_public_path__ + "static/media/zoom_in_outline.6a672c1e5b23741bdf1797542be6bca7.svg";
export { ForwardRef as ReactComponent };